import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { fileUrl } from "@/lib/api";
import useSeo from "@/lib/useSeo";

export default function About() {
  const { t, site } = useApp();
  const a = site?.about || {};
  useSeo({ title: t("about"), description: a.title });
  return (
    <div data-testid="about-page">
      <section className="max-w-[1400px] mx-auto px-4 sm:px-8 py-16 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5 space-y-6">
          <p className="font-mono text-xs tracking-[0.25em] text-[#8C4F27]">{t("about").toUpperCase()}</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05]" data-testid="about-title">{a.title}</h1>
          <div className="text-[#6E6259] leading-relaxed space-y-4" data-testid="about-body">{(a.body || "").split(/\n\n+/).map((p, i) => <p key={i}>{p}</p>)}</div>
          <Link to="/shop" className="inline-block bg-[#3B220C] text-white px-8 py-3 text-sm">{t("explore")}</Link>
        </div>
        {a.image && <img className="lg:col-span-7 w-full aspect-[4/3] object-cover" alt="Craftendemic" src={fileUrl(a.image)} />}
      </section>
    </div>
  );
}
